import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, setAuthToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function Handoff() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("This link is missing its sign-in token."); return; }
    (async () => {
      try {
        setAuthToken(null);
        const { data } = await api.post("/auth/handoff/exchange", { token });
        setAuthToken(data.token);
        await refresh();
        navigate(data.next || "/onboarding", { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "This sign-in link has expired or was already used.");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="tenant-portal flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F7F8FA] px-6 text-center" data-testid="handoff-page">
      {error ? (
        <>
          <h1 className="text-xl font-extrabold text-neutral-800" data-testid="handoff-error">We couldn't sign you in</h1>
          <p className="max-w-sm text-sm text-neutral-500">{error}</p>
          <a href="/login" className="rounded-full bg-[#0A8B85] px-5 py-2.5 text-sm font-bold text-white" data-testid="handoff-login-link">Sign in with your email and password</a>
        </>
      ) : (
        <>
          <Loader2 className="h-7 w-7 animate-spin text-[#0A8B85]" />
          <p className="text-sm font-semibold text-neutral-700" data-testid="handoff-loading">Setting up your Clinq account and bringing your details across…</p>
        </>
      )}
    </div>
  );
}
